import React from 'react'
import { Checkbox, Col, Flex, Form, Input, Row, Select, Typography, Upload } from 'antd'
import { ErrorMessage } from '@hookform/error-message'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { PathIcon } from 'src/assets/icons'
import { useSelector } from 'react-redux'
import { getLookupValues } from 'src/app/store/masterSetup'
import SkipRowsRangeField from '../skip-rows-range-field'

interface Props {
  errors: any
  control: any
}

function UploadForm(props: Props) {
  const { t } = useTranslation()

  const lookupValues = useSelector(getLookupValues)

  const { FormatType, TextQualifier } = lookupValues || {}

  const { errors, control } = props

  return (
    <Flex vertical>
      <Row gutter={24} align='middle'>
        <Col span={12}>
          <Form.Item label={t('FileMappingSetup:addFileMapping.label.formatName')} className='isRequired'>
            <Controller
              name='formatName'
              control={control}
              render={({ field, fieldState }) => (
                <Input
                  {...field}
                  className='ant-input-view-only'
                  status={!!fieldState.error ? 'error' : ''}
                  placeholder={t('FileMappingSetup:addFileMapping.placeholder.formatName')}
                  onBlur={(e) => {
                    field.onChange(e?.target?.value?.trim())
                  }}
                  maxLength={50}
                />
              )}
              disabled
            />
            <Typography className='error-message'>
              <ErrorMessage errors={errors} name='formatName' />
            </Typography>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={t('FileMappingSetup:addFileMapping.label.formatType')} className='isRequired'>
            <Controller
              name='formatType'
              control={control}
              render={({ field, fieldState }) => (
                <Select
                  {...field}
                  status={!!fieldState.error ? 'error' : ''}
                  options={FormatType}
                  placeholder={t('FileMappingSetup:addFileMapping.placeholder.formatType')}
                />
              )}
              disabled
            />
            <Typography className='error-message'>
              <ErrorMessage errors={errors} name='formatType' />
            </Typography>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24} align='middle'>
        <Col span={12}>
          <Form.Item valuePropName='checked'>
            <Controller
              name='fileContainsIssuedDate'
              control={control}
              render={({ field }) => (
                <Checkbox {...field} checked={field.value}>
                  {t('FileMappingSetup:addFileMapping.label.fileContainsIssuedDate')}
                </Checkbox>
              )}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Flex align='center' gap={16} wrap='wrap' className='skip-rows-range-group'>
            <Form.Item valuePropName='checked'>
              <Controller
                name='fileContainsHeaderRow'
                control={control}
                render={({ field }) => (
                  <Checkbox {...field} checked={field.value}>
                    {t('FileMappingSetup:addFileMapping.label.fileContainsHeaderRow')}
                  </Checkbox>
                )}
                disabled
              />
            </Form.Item>

            <SkipRowsRangeField errors={errors} control={control} disabled />
          </Flex>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label={t('FileMappingSetup:addFileMapping.label.textQualifier')} className='isRequired'>
            <Controller
              name='textQualifier'
              control={control}
              render={({ field, fieldState }) => (
                <Select {...field} status={!!fieldState.error ? 'error' : ''} options={TextQualifier} />
              )}
              disabled
            />
            <Typography className='error-message'>
              <ErrorMessage errors={errors} name='textQualifier' />
            </Typography>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={t('FileMappingSetup:addFileMapping.label.sampleFile')} className='isRequired'>
            <Controller
              name='sampleFile'
              control={control}
              render={({ field, fieldState }) => (
                <Input
                  {...field}
                  status={!!fieldState.error ? 'error' : ''}
                  className='sample-file-upload'
                  placeholder={t('FileMappingSetup:addFileMapping.placeholder.sampleFile')}
                  prefix={<PathIcon />}
                  suffix={
                    <Upload showUploadList={false} className='upload-button' disabled>
                      {t('OverallFunctionality:select_btn')}
                    </Upload>
                  }
                  readOnly
                />
              )}
            />
            <Typography className='error-message'>
              <ErrorMessage errors={errors} name='sampleFile' />
            </Typography>
          </Form.Item>
        </Col>
      </Row>
    </Flex>
  )
}

export default UploadForm
